import './components/custom-select';

// Animations
document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-animate]');

    if (!('IntersectionObserver' in window)) {
        elements.forEach(el => el.classList.add('visible'));
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0
    });

    elements.forEach(el => {
        const animationClass = 'animate-' + el.dataset.animate;
        el.classList.add(animationClass);
        observer.observe(el);
    });
});

// To top
document.addEventListener("DOMContentLoaded", function() {
    const scrollToTopBtn = document.getElementById("to-top");
    if (!scrollToTopBtn) return; //

    let scrollFrame = null;
    let wasVisible = null;

    function scrollFunction() {
        const visible = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
        if (visible === wasVisible) return;
        wasVisible = visible;

        if (visible) {
            scrollToTopBtn.style.display = "flex";
            scrollToTopBtn.style.justifyContent = "center";
            scrollToTopBtn.style.alignItems = "center";
        } else {
            scrollToTopBtn.style.display = "none";
        }
    }

    window.addEventListener('scroll', () => {
        if (scrollFrame !== null) return;
        scrollFrame = window.requestAnimationFrame(() => {
            scrollFrame = null;
            scrollFunction();
        });
    }, { passive: true });
    scrollFunction();

    scrollToTopBtn.addEventListener("click", function() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });
});

// Bar margin
document.addEventListener('DOMContentLoaded', function () {
    const infoBar = document.querySelector('.js-info-bar');
    const closeBtn = document.querySelector('.js-info-bar-close');
    const siteHeader = document.querySelector('.site-header');

    if (infoBar && siteHeader) {
        siteHeader.classList.add('js-bar-space');
    }

    if (closeBtn && infoBar && siteHeader) {
        closeBtn.addEventListener('click', function () {
            infoBar.style.display = 'none';
            siteHeader.classList.remove('js-bar-space');
        });
    }
});

// Placeholder typing effect (responsive)
document.addEventListener("DOMContentLoaded", function () {
    const inputs = document.querySelectorAll(".js-typing-placeholder");
    if (!inputs.length) return;

    const textsDesktop = [
        "Lavagna magnetica bianca 90x60cm",
        "Lavagna nera a gesso con cornice in legno",
        "Lavagna in vetro cancellabile a secco",
        "Cavalletto pubblicitario da marciapiede",
    ];

    const textsMobile = [
        "Cerca",
        "Lavagna",
        "Produttore",
        "Qualità"
    ];

    const typingSpeed = 60;
    const deletingSpeed = 35;
    const pauseAfterType = 4000;
    const pauseAfterDelete = 2000;

    function getTexts() {
        return window.innerWidth <= 1050 ? textsMobile : textsDesktop;
    }

    inputs.forEach((input) => {
        let textIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        let timeoutId;

        function tick() {
            const texts = getTexts();

            if (!texts.length) return;

            textIndex = textIndex % texts.length;

            const currentText = texts[textIndex];

            if (!isDeleting) {
                charIndex++;
                input.setAttribute("placeholder", currentText.substring(0, charIndex));

                if (charIndex >= currentText.length) {
                    isDeleting = true;
                    timeoutId = setTimeout(tick, pauseAfterType);
                    return;
                }

                timeoutId = setTimeout(tick, typingSpeed);
            } else {
                charIndex--;
                input.setAttribute("placeholder", currentText.substring(0, charIndex));

                if (charIndex <= 0) {
                    isDeleting = false;
                    charIndex = 0;
                    textIndex = (textIndex + 1) % texts.length;
                    timeoutId = setTimeout(tick, pauseAfterDelete);
                    return;
                }

                timeoutId = setTimeout(tick, deletingSpeed);
            }
        }

        tick();

        window.addEventListener("resize", () => {
            const texts = getTexts();
            if (!texts.length) return;

            textIndex = textIndex % texts.length;

            const currentText = texts[textIndex] || "";
            charIndex = Math.min(charIndex, currentText.length);
        });
    });
});

// Realizations filters
document.addEventListener('DOMContentLoaded', () => {
    const grids = document.querySelectorAll('.js-realizations');

    if (!grids.length) return;

    grids.forEach((grid) => {
        const section = grid.closest('.realizations');
        if (!section) return;

        const links = section.querySelectorAll('.section__filter-btn, .pagination a');

        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                const href = link.getAttribute('href');

                if (!href || href.startsWith('#')) return;
                if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                if (link.target === '_blank') return;

                e.preventDefault();

                grid.classList.add('is-loading');

                const target = section.querySelector('.section__items') || grid;
                const offset = 100;

                if (!target) {
                    window.location.href = href;
                    return;
                }

                const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({
                    top,
                    behavior: 'smooth'
                });

                setTimeout(() => {
                    window.location.href = href;
                }, 500);
            });
        });
    });
});

// Custom select
document.addEventListener('DOMContentLoaded', () => {
    const selects = document.querySelectorAll('select');

    if (!selects.length) return;

    selects.forEach((select) => {
        const open = () => select.classList.add('open');
        const close = () => select.classList.remove('open');

        select.addEventListener('mousedown', open);
        select.addEventListener('touchstart', open);
        select.addEventListener('blur', close);
        select.addEventListener('change', close);
    });
});

// Search overlay
document.addEventListener('DOMContentLoaded', function () {
    const body = document.body;
    const searchForm = document.getElementById('searchform');
    const searchInput = document.getElementById('s-desktop');
    const clearButton = searchForm ? searchForm.querySelector('.search-clear') : null;

    if (!searchForm || !searchInput) return;

    function toggleClearButton() {
        if (!clearButton) return;
        clearButton.style.display = searchInput.value.trim() ? 'inline-flex' : 'none';
    }

    function openOverlay() {
        body.classList.add('search-active');
    }

    function closeOverlay() {
        body.classList.remove('search-active');
    }

    searchForm.addEventListener('focusin', function () {
        openOverlay();
    });

    document.addEventListener('click', function (e) {
        if (!searchForm.contains(e.target)) {
            closeOverlay();
        }
    });

    document.addEventListener('focusin', function (e) {
        if (!searchForm.contains(e.target)) {
            closeOverlay();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeOverlay();
            searchInput.blur();
        }
    });

    searchInput.addEventListener('input', toggleClearButton);

    if (clearButton) {
        clearButton.addEventListener('click', function (e) {
            e.preventDefault();
            searchInput.value = '';
            toggleClearButton();
            searchInput.focus();
        });
    }

    toggleClearButton();
});

// Show more filters
document.querySelectorAll('.filter-group__toggle').forEach((button) => {
    button.addEventListener('click', () => {
        const group = button.closest('.filter-group');
        const isExpanded = group.classList.toggle('is-expanded');

        button.setAttribute('aria-expanded', String(isExpanded));
        button.textContent = isExpanded
            ? 'Mostra meno'
            : 'Mostra di più';
    });
});

// Keep untouched contextual price limits out of the filter URL.
document.querySelectorAll('.filters__form').forEach((form) => {
    form.addEventListener('submit', () => {
        form.querySelectorAll('input[name="min_price"], input[name="max_price"]').forEach((input) => {
            const isDefaultValue = input.dataset.priceFilterActive === '0'
                && input.value === input.dataset.priceDefault;

            if (input.value.trim() === '' || isDefaultValue) {
                input.disabled = true;
            }
        });
    });
});

// Grid/list products
document.addEventListener('DOMContentLoaded', () => {
    const groups = [
        {
            items: document.querySelector('.product-archive__items'),
            switcher: document.querySelector('.product-view-switcher:not([data-product-view-switcher])'),
            storageKey: 'ml-product-archive-view',
        },
        {
            items: document.querySelector('[data-product-view-items="wishlist"]'),
            switcher: document.querySelector('[data-product-view-switcher="wishlist"]'),
            storageKey: 'ml-product-wishlist-view',
        },
    ];

    groups.forEach(({ items, switcher, storageKey }) => {
        if (!items || !switcher) return;

        const savedView = localStorage.getItem(storageKey);
        const initialView = savedView === 'list' ? 'list' : 'grid';

        const setView = (view) => {
            items.classList.toggle('is-grid', view === 'grid');
            items.classList.toggle('is-list', view === 'list');

            switcher.querySelectorAll('[data-product-view]').forEach((button) => {
                const active = button.dataset.productView === view;

                button.classList.toggle('is-active', active);
                button.setAttribute('aria-pressed', String(active));
            });

            localStorage.setItem(storageKey, view);
        };

        setView(initialView);

        switcher.addEventListener('click', (event) => {
            const button = event.target.closest('[data-product-view]');
            if (!button) return;

            setView(button.dataset.productView);
        });
    });
});

// Pages hot deal
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hot-deal-countdown]').forEach((countdown) => {
        const end = Number(countdown.dataset.end || 0) * 1000;
        const endedLabel = countdown.dataset.endedLabel || '';
        const section = countdown.closest('.pages-hot-deal');
        const status = section?.querySelector('.pages-hot-deal__timer-status');

        const fields = {
            days: countdown.querySelector('[data-countdown-days]'),
            hours: countdown.querySelector('[data-countdown-hours]'),
            minutes: countdown.querySelector('[data-countdown-minutes]'),
            seconds: countdown.querySelector('[data-countdown-seconds]'),
        };

        if (!end) {
            section?.remove();
            return;
        }

        const render = () => {
            const remaining = Math.max(0, end - Date.now());
            const totalSeconds = Math.floor(remaining / 1000);

            const values = {
                days: Math.floor(totalSeconds / 86400),
                hours: Math.floor((totalSeconds % 86400) / 3600),
                minutes: Math.floor((totalSeconds % 3600) / 60),
                seconds: totalSeconds % 60,
            };

            Object.entries(values).forEach(([key, value]) => {
                if (fields[key]) {
                    fields[key].textContent = String(value).padStart(2, '0');
                }
            });

            if (remaining === 0) {
                countdown.classList.add('is-ended');

                if (status) {
                    status.textContent = endedLabel;
                }

                section?.remove();
                return false;
            }

            return true;
        };

        if (!render()) {
            return;
        }

        const interval = window.setInterval(() => {
            if (!render()) {
                window.clearInterval(interval);
            }
        }, 1000);
    });
});
